<script>
    import { registerUser } from '@/api/user.js';

    export default {
        computed: {
            isSaveAdd() {return this.$store.getters.IS_SAVE_ADD_DATA}
        },
        methods: {
            async create() {
                const newUser = await registerUser(
                    this.$store.getters.USER_ADD_DATA
                );
                if (newUser != null) {
                    this.$store.commit('USERS_PUSH', newUser);
                }
            },
            async close() {
                this.$store.commit('IS_SHOW_UDER_ADD', false);
            },
            async clear() {
                this.$store.commit('USER_ADD_DATA', {
                    name: '', company: '', email: '', password: ''
                });
                await this.$store.dispatch('CHECK_USER_ADD');
            }
        }
    }
</script>


<template>
    <div>
        <button
            :disabled="isSaveAdd === false"
            class="button_blue_100"
            @click="create"
        >Create</button>
        <button
            class="button_blue_100 ml_10"
            @click="clear"
        >Clear</button>
        <button
            class="button_blue_100 close_button mr_10"
            @click="close"
        >Close</button>
    </div>
</template>